import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';

interface Report {
  companyName: string,
  cashBalance: number,
  bankBalance: number,
  companyId: number,
  latestCheckin?: Date,
  checkinBy?: string
}

@Component({
    selector: 'app-cash-balance-report',
    templateUrl: './cash-balance-report.component.html',
    styleUrls: ['./cash-balance-report.component.scss'],
    standalone: false
})
export class CashBalanceReportComponent implements OnInit, OnDestroy, OnChanges {
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);
  private activatedRoute = inject(ActivatedRoute);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);

  endDate: Date;
  companyGroup: number;

  reportList: Report[] = [];
  isCollapsed = false;
  routeSubscription: any;
  warningAmount = 20000;
  filterWarning = false;

  fullReportList: Report[] = [];

  ngOnInit(): void {
    this.routeSubscription = this.activatedRoute.paramMap.subscribe(params => {
      this.endDate = (params.get('endDate') == undefined) ? undefined : new Date(params.get('endDate'));
      this.companyGroup = (params.get('companyGroup') == undefined) ? undefined : Number(params.get('companyGroup'));

      this.getCashAndBankBalance();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.companyGroup) {
      this.getCashAndBankBalance();
    }

  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }

  getCashAndBankBalance() {

    this.reportList = [];
    this.fullReportList = [];

    if (this.endDate != undefined)
      //in order to get the correct result, end date need to add 1 day and minus 1 millisecond
      // 3600*1000*24 is 1 day in millisecond, then reduced by 1 millisecond
      var addADayDate = new Date(Number(this.endDate) + (3600 * 1000 * 24) - 1);
    const endDateStr = (this.endDate == undefined) ? undefined : addADayDate.toISOString();

    const xhttp = (this.companyGroup == 0)
      ? this.restapi.getRequest(this.constructApi.getCompaniesCashBalance(endDateStr, 500))
      : this.restapi.getRequest(this.constructApi.getCompanyGroupCompaniesCashBalance(this.companyGroup, endDateStr, 500));

    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));
        jsonArray.forEach(json => {

          const cashBalance = (json.cash == undefined) ? 0 : json.cash;
          const bankBalance = (json.bank == undefined) ? 0 : json.bank;

          const report = { companyName: json.companyCode, cashBalance: cashBalance, bankBalance: bankBalance, companyId: json.id }
          this.fullReportList.push(report);

        }
        );

        this.fullReportList.sort((a, b) => (a.companyName < b.companyName ? -1 : 1));
        this.getAllCompaniesLatestCheckins();
      }
    };
  }

  calculateTotalBalance() {
    let total = 0;
    for (let i = 0; i < this.reportList.length; i++) {
      total += this.reportList[i].bankBalance + this.reportList[i].cashBalance;
    }

    return total;
  }

  getAllCompaniesLatestCheckins() {
    const xhttp = this.restapi.getRequest(this.constructApi.getCompaniesLatestCheckIns())

    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));
        jsonArray.forEach(json => {

          const index = this.fullReportList.findIndex(report => report.companyId === json.companyId);

          if (index != -1) {
            this.fullReportList[index].latestCheckin = new Date(json.date);
            this.fullReportList[index].checkinBy = json.username;
          }

        }
        );

        this.filterWarningCompanies();
      }
    };
  }

  filterWarningCompanies() {

    if (this.filterWarning == true) {
      this.reportList = [];
      this.reportList = this.fullReportList.filter(company => { return Number(company.bankBalance + company.cashBalance) > Number(this.warningAmount) });
    }
    else
      this.reportList = this.fullReportList;
  }
}
